// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/montageteil-maschinenbau/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteMontageteilMaschinenbauDE: PageEntry = {
  id: "example.produkte-montageteil-maschinenbau",
  locale: "de",
  slug: "produkte/montageteil-maschinenbau",
  seo: {
    title: "Montageteil Maschinenbau | Dietz GmbH",
    description: "Platinen schneiden, biegen im Musterbau, vernieten der einzelnen Elemente. Zur Funktion ist zu sagen, dass zwischen den Federblechen ein zylindrischer Körper mit Durchmesser Ø38,7 ",
  },
  type: "post",
  h1: "Montageteil Maschinenbau",
  intro: "Platinen schneiden, biegen im Musterbau, vernieten der einzelnen Elemente. Zur Funktion ist zu sagen, dass zwischen den Federblechen ein zylindrischer Körper mit Durchmesser Ø38,7 +/-0,2 mm fixiert und damit in Position gehalten werden soll.",
  blocks: [
    { kind: "image", src: "/images/live/dtz-montageteil-maschinenbau.jpg", alt: "Montageteil Maschinenbau", width: 1400, height: 1120 }
  ],
};
